const GAME_CALLBACK = {
    UNREAD_ANNOUNCEMENTS: `setCapToolNotifications`,
    PAGE_LOAD_STARTING: `pageLoadStarting`
}

const GAME = {
    BIG_FARM: 'bigfarm',
    EMPIRE: 'empire',
    E4K: 'empirefourkingdoms'
}

const GAME_BUTTON_CLICKED_PREFIX = 'game.button.clicked.'

const GAME_ANNOUNCEMENTS_EVENT = {
    GET_ANNOUNCEMENTS: `${GAME_BUTTON_CLICKED_PREFIX}getAnnouncements`,
    OPEN_ANNOUNCEMENTS: `${GAME_BUTTON_CLICKED_PREFIX}openAnnouncements`
}

module.exports = {
    GAME_CALLBACK,
    GAME,
    GAME_BUTTON_CLICKED_PREFIX,
    GAME_ANNOUNCEMENTS_EVENT,
    OPEN: GAME_ANNOUNCEMENTS_EVENT.OPEN_ANNOUNCEMENTS,
    GET: GAME_ANNOUNCEMENTS_EVENT.GET_ANNOUNCEMENTS
}
